var Header = function() {

	var self = this;
	var $func;

	this.init = function() {

		if ($(window).width() <= 1024) {
			$func = 'click';
		} else {
			$func = 'mouseenter';
		}

		this.toggleLogin($func);

		this.toggleSubmenu($func);

		this.openMenu();

		this.focusLogin();

		//this.inputMask();

		this.closeMenu();

		//this.controlError();

		this.scrollMenu();

		this.alignAccount();

	};

	this.toggleSubmenu = function($func){
		$('[data-component="header"] .menu-list > li').stop().on($func,  function(e) {
			e.stopPropagation();

			if ($(e.target).closest('.submenu').length < 1) {
				
				if ($(this).hasClass('menu-on')) {
					self.hideMenu();
					$(this).removeClass('menu-on');
				} else {
					self.hideMenu();
				
					$('.menu-on').removeClass('menu-on');
					$(this).addClass('menu-on');
					if ($(this).find('.submenu').length) {
						var submenu = $(this).find('.submenu');
						var submenuHeigth = submenu.outerHeight();
		
						submenu.show();
		
						$(this).find('.arrow').addClass('active');
						if ($(window).width() > 1024) {
							$('[data-component="header"] .header-left').addClass('submenu-active');
		
							TweenMax.to('[data-component="header"] .menu-list > li > a', '.3', {opacity: '.5', ease: Sine.easeOut});
							TweenMax.to($(this).find('.arrow'), '.3', {opacity: 1, ease: Sine.easeOut});
							TweenMax.to('[data-component="header"] .layer-submenu', '.7', {height: submenuHeigth, ease: Sine.easeOut});
							TweenMax.to(submenu, '.7', {delay: '.3', autoAlpha: 1, top: '10px', ease: Sine.easeOut});
						} else {
		
							var menuItem = $(this);
							var heightItem = submenuHeigth + $(this).outerHeight();
		
							TweenMax.to('[data-component="header"] .menu-list > li > a', '.3', {opacity: '.5', ease: Sine.easeOut});
							TweenMax.to($(this).find('.arrow'), '.3', {opacity: 1, ease: Sine.easeOut});
							TweenMax.to(menuItem, '.7', {height: heightItem + 20, ease: Sine.easeOut});
							TweenMax.to(submenu, '.7', {delay: '.3', autoAlpha: 1, top: 0, ease: Sine.easeOut});
						}
					}
	
				}

			}
			
		});

		$('[data-component="header"] .menu-list').stop().on('mouseleave', function(e) {
			self.hideMenu();
		});

	};

	this.hideMenu = function() {
		$('[data-component="header"] .menu-list a.arrow').removeClass('active');

		if ($(window).width() > 1024) {
			//$('[data-component="header"] .header-left').removeClass('submenu-active');

			TweenMax.to('[data-component="header"] .menu-list .submenu', '.2', {autoAlpha: 0, top: '-40%', ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .layer-submenu', '.4', {height: 0, ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .menu-list a', '.3', {opacity: 1, ease: Sine.easeOut});
		} else {
			TweenMax.to('[data-component="header"] .menu-list .submenu', '.3', {autoAlpha: 0, ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .menu-list a', '.3', {opacity: 1, ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .menu-list > li', '.3', {height: 50, ease: Sine.easeOut});
		}

		$('[data-component="header"] .menu-list .submenu').hide();
	};

	this.closeSubmenu = function() {
		$('[data-component="header"] .menu-list a.arrow').removeClass('active');
		if ($(window).width() > 1024) {
			$('[data-component="header"] .header-left').removeClass('submenu-active');

			TweenMax.to('[data-component="header"] .menu-list .submenu', '.2', {autoAlpha: 0, top: '-40%', ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .layer-submenu', '.4', {height: 0, ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .menu-list a', '.3', {opacity: 1, ease: Sine.easeOut});
		} else {
			TweenMax.to('[data-component="header"] .menu-list .submenu', '.3', {autoAlpha: 0, ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .menu-list a', '.3', {opacity: 1, ease: Sine.easeOut});
			TweenMax.to('[data-component="header"] .menu-list > li', '.3', {height: 50, ease: Sine.easeOut});
		}
	};
	/*this.inputMask = function(){
		var options = {
			onKeyPress: function (cpf, ev, el, op) {
				var masks = ['000.000.000-000', '00.000.000/0000-00'],
						mask = (cpf.length > 14) ? masks[1] : masks[0];
				el.mask(mask, op);
			}
		};

		$('[data-component="header"] .holder-input input').mask('000.000.000-000', options);
	};*/

	this.focusLogin = function(){

		$('[data-component="header"] .holder-input input').on('focus', function() {
			TweenMax.to('[data-component="header"] .holder-input', 0, {autoAlpha: 1, ease: Quint.easeIn});
		});

		$('[data-component="header"] .holder-input input').on('focusout', function() {
			TweenMax.to('[data-component="header"] .holder-input', 0, {autoAlpha: '.5', ease: Quint.easeOut});
		});

	};

	this.toggleLogin = function ($func){
		
		$('[data-component="header"] .holder-login').on($func, function(e) {

			if (!$(e.target).hasClass('icon-white-arrow-down')) {
				TweenMax.to('[data-component="header"] .my-account-box span', '.5', {left: '150%', ease: Power3.easeOut});
				TweenMax.to('[data-component="header"] .my-account-box', '.5', {left: '100%', delay: '.3', ease: Power3.easeOut});
				TweenMax.to('[data-component="header"] .my-account-login', '.5', {right: 0, delay: '.3', ease: Power3.easeOut});
	
				if ($(window).width() < 768) {
					TweenMax.to("[data-component='header'] .header-right", .4, {'height': '312px'});
				}
	
				$("[data-component='header'] .my-account-login").css({'height': '100%','top': '0'});
				$("[data-component='header'] .my-account-box").css({'height': '100%','top': '0'});
				$("[data-component='header'] .holder-login").css({'height': '100%', 'top': '0'});

			}
		})

		if ($(window).width() >= 1024) {
			$('[data-component="header"] .holder-login').on('mouseleave', function () {
				self.closeLogin();
			});
		} else {
			$('[data-component="header"] .holder-login .icon-white-arrow-down').on('click', function (e) {
				self.closeLogin();
			});
		}

		$("[data-component='header'] .my-account-login .icon-white-arrow-down").on('click', function(){
			self.closeLogin();
		});
	};

	this.closeLogin = function() {
		TweenMax.to('[data-component="header"] .my-account-box span', '.5', {left: '50%', ease: Power3.easeOut});
		TweenMax.to('[data-component="header"] .my-account-box', '.5', {left: 0, delay: '.3', ease: Power3.easeOut});
		TweenMax.to('[data-component="header"] .my-account-login', '.5', {right: '100%', delay: '.3', ease: Power3.easeOut});

		if ($(window).width() >= 1024) {
			// $("[data-component='header'] .my-account-login").css({'height': '60%','top': '36px'});
			// $("[data-component='header'] .my-account-box").css({'height': '60%','top': '36px'});
		} else {
			TweenMax.to("[data-component='header'] .header-right", .4, {'height': '54px'});
		}

		$("[data-component='header'] .holder-login").css('height', '100%');
	};

	this.openMenu = function(){

		$('[data-component="header"] .mobile-menu').on('click', function() {
			TweenMax.to('[data-component="header"] .holder-menu', '.7', {width: '100%', ease: Power3.easeOut});
			TweenMax.to('[data-component="header"] .header-right', '.7', {width: '100%', ease: Power3.easeOut});
			TweenMax.to('[data-component="header"] .layer-menu', '.5', {autoAlpha: '.3', ease: Power3.easeOut});
			TweenMax.to('[data-component="header"] .close-menu', '1.2', {autoAlpha: 1, ease: Power3.easeOut});
			$('body').css("overflow", "hidden");
		});
		if($(window).width() < 768){
			$('[data-component="header"] .holder-login .my-account-box').on('click', function() {
				TweenMax.to('[data-component="header"] .holder-menu', '.7', {width: '100%', ease: Power3.easeOut});
				TweenMax.to('[data-component="header"] .header-right', '.7', {width: '100%', ease: Power3.easeOut});
			})
		}

	};

	this.closeMenu = function(){

		$('[data-component="header"] .close-menu').on('click', function() {
			TweenMax.to('[data-component="header"] .holder-menu', '.5', {width: 0, ease: Power3.easeOut});
			TweenMax.to('[data-component="header"] .header-right', '.5', {width: 0, ease: Power3.easeOut});
			TweenMax.to('[data-component="header"] .layer-menu', '.3', {autoAlpha: 0, ease: Power3.easeOut});
			TweenMax.to('[data-component="header"] .close-menu', '.5', {autoAlpha: 0, ease: Power3.easeOut});
			$('body').css("overflow", "auto");
		});

	};

	/*this.controlError = function(){

		$('[data-component="header"] .icon-arrow-right').on('click', function() {

			var length = $('[data-component="header"] .holder-input input').val().length;
			var inputValue = $('[data-component="header"] .holder-input input').val();

			if(length < 14) {
				$('[data-component="header"] .error-layer .text').text('Preencha o campo corretamente.');
				toTop();
				error();
			}
			else if(length === 14 && ((inputValue) !== ('111.111.111-11'))) {
				$('[data-component="header"] .error-layer .text').text('Não encontramos o seu usuário cadastrado. Por favor tente novamente ou cadastre-se/abra sua conta.');
				toTop();
				error();
			}
			else if(length > 14 && (inputValue !== ('11.111.111/1111-11'))){
				$('[data-component="header"] .error-layer .text').text('Não encontramos sua empresa em nosso cadastro. Abra sua conta ou digite novamente.');
				toTop();
				error();
			}
			else {
				$('[data-component="header"] .hidden').trigger('click');
			}

			$("html, body").on('click', function(e){
				if(!$(e.target).is('.icon-arrow-right')){
					toClose();
				}
			})

		});

		function error(){
			$('[data-component="header"] #loginform input').addClass('error');
			$('[data-component="header"] #loginform label').addClass('error');
			$('[data-component="header"] #loginform label').text('Usuário inválido');
		}


		function toClose(){
			TweenMax.to('[data-component="header"] .error-layer', '.1', { opacity:0, ease: Power4.easeOut});
		}

		function toTop(){
			if($(window).width() > 768) {
				TweenMax.to('[data-component="header"] .error-layer', '2', {autoAlpha: 1, top: '90%', opacity:1, ease: Power4.easeOut});
			} else {
				TweenMax.to('[data-component="header"] .error-layer', '2', {autoAlpha: 1, top: '-150%', opacity:1, ease: Power4.easeOut});
			}
		}

	};*/

	this.alignAccount = function() {
		if($(window).width() > 1024) {
			// $('.main-link').next('.submenu-holder').find('li').css('margin-left', $('.main-link').position().left + 'px');
			$('.menu-list .arrow').each(function() {

				if($(this).parent().find(".submenu-holder > .submenu > li").length > 0) {
					$(this).next('.submenu-holder').find('li').css('margin-left', $(this).position().left + 'px');
				}

				/*if($(this).text() == "Para você" || $(this).text() == "Abra sua conta" || $(this).text() == "Personal Banking") {
					$(this).next('.submenu-holder').find('li').css('margin-left', $(this).position().left + 'px');
				}*/
			});

		}
	}


	this.scrollMenu = function(){
		var subHead = $('[data-component="subhead"]').css("display") === "none" ? true : false;
		var hideMenu = $(window).scrollTop();

		$(document).on('scroll', function(){
			var tamanhoAtual = $(window).scrollTop();
			if(tamanhoAtual < 10){
				TweenMax.to('[data-component="header"]', 0.01, {css: {top: 0}});
				//TweenMax.to($("body"), 0.7, {paddingTop: '120px'});
				if(!subHead){
					TweenMax.to('[data-component="subhead"]', 0.01, {opacity: 1, visibility: "visible"});	
				}
				hideMenu = tamanhoAtual;

			}else if(hideMenu < tamanhoAtual){
				TweenMax.to('[data-component="header"]', 0.01, {css: {top: '-90px'}});
				//TweenMax.to($("body"), 0.01, {paddingTop: 0});
				if(!subHead){
					TweenMax.to('[data-component="subhead"]', 0.01, {opacity: 0, visibility: "hidden"});
				}
				hideMenu = tamanhoAtual;
			} else {	
				
				TweenMax.to('[data-component="header"]', 0.01, {css: {top: 0}});
				//TweenMax.to($("body"), 0.7, {paddingTop: '120px'});
				if(!subHead){
					TweenMax.to('[data-component="subhead"]', 0.01, {opacity: 1, visibility: "visible"});	
				}
				hideMenu = tamanhoAtual;
			}
		});
	}
	return this.init();
};
